console.log('in marketplace overview');

(async function() {
	var MARKETPLACE_HTML = document.querySelector('.awesomeplus-marketplace');
	var isDev = localStorage['dev'] ? true : false;
	if (isDev) {
	  APIHOST = 'https://8fb2-61-92-0-169.ngrok.io/api/storefront';
	} else {
	  APIHOST = 'https://awesomeplus-marketplace-urrrdk7f2q-de.a.run.app/api/storefront'
	}

	var data = await fetch(`${APIHOST}/marketplace`).then(res => res.json()).then(data => data);

	console.log(data);

	if (data.length) {
		data.forEach(d => {
			console.log(d);
			MARKETPLACE_HTML.insertAdjacentHTML('beforeend', d.html);
		})
	} else {
		var no_store_reminder = `
		<div class="no-store-reminder reading-container">
			<div class="text-xl font-bold text-center" style="margin: 1.5rem 0;">商戶正忙於備貨，敬請期待！</div>
		</div>
		`;
		MARKETPLACE_HTML.insertAdjacentHTML('beforeend', no_store_reminder);
	}
})();